import get from 'lodash/get';
import { connect } from 'react-redux';
import { getActiveType, getShop, getActiveBrandId, getActiveShop } from '../../auth/selectors';

export const getActiveUserIdAndType = (state, opts = {}) => {
  const barber = get(state.auth.barberUser, 'id');
  let brand = getActiveBrandId(state);
  const shop = getShop(state);
  const activeShop = getActiveShop(state);
  let activeType = getActiveType(state);

  if (barber && opts.useShopForBarber) {
    activeType = 'shop';
  }

  if (opts.useBrandForShop && activeType === 'shop' && activeShop.brandId) {
    brand = activeShop.brandId;
    activeType = 'brand';
  }

  return {
    activeId: ({ barber, brand, shop })[activeType],
    activeType,
  };
};

const mapStateToProps = opts => state => getActiveUserIdAndType(state, opts);

export default (opts = {
  useShopForBarber: false,
  useBrandForShop: false,
}) => connect(mapStateToProps(opts));
